module.exports = __webpack_public_path__ + "img/charity.711d9d1f.png";